import { GetTermsGlobalAccountApiProps } from 'services/terms-global-account/types'
import { Term } from 'services/terms-and-conditions/types'

import { interWbNavigate } from '@interco/inter-webview-bridge'

export const openTermDocument = (item: Term) => {
  if (!item.url) return

  if (item.openMode === 'externalUrl') {
    interWbNavigate.openNativeBrowser(item.url)
    return
  }

  interWbNavigate.openPdf(item.title, item.url)
}

export const handleSelectTerm = (item: GetTermsGlobalAccountApiProps) => {
  openTermDocument(item)
}

export const handleSelectTermsAndConditions = (item: Term) => {
  openTermDocument(item)
}
